export const GET_SYNC_MEMBER_MESSAGES = 'GET_SYNC_MEMBER_MESSAGES';
export const SCHEDULE_INVITATION_AGREED = 'SCHEDULE_INVITATION_AGREED';
export const SCHEDULE_INVITATION_REFUSED = 'SCHEDULE_INVITATION_REFUSED';
// 获取日历事件列表
export const GET_CALENDAR_EVENTS = 'GET_CALENDAR_EVENTS';
export const GET_BUSINESS_UNIT_LIST = 'GET_BUSINESS_UNIT_LIST';
export const GET_DEPART_MEND_USERS = 'GET_DEPART_MEND_USERS';
export const CURRENT_USER_INFO = 'CURRENT_USER_INFO';
export const CURRENT_DEPT_INFO = 'CURRENT_DEPT_INFO';
export const GET_FOLLOWED_USERS = 'GET_FOLLOWED_USERS';
export const CHANGE_CURRENT_USER = 'CHANGE_CURRENT_USER';
